import * as React from 'react';
var DropdownContext = /*#__PURE__*/React.createContext({});
DropdownContext.displayName = 'DropdownContext';
export default DropdownContext;